/**
 * Cho'ktiruvchi quvurli sentrifuga — UnitModel.
 *
 * OGOHLANTIRISH KODLARI (i18n):
 *   cent.overspeed      critical  n > n_max (params: speed, maxSpeed) — n_max ga cheklanadi
 *   cent.bowlFull       critical  baraban cho'kma bilan to'lgan (params: fill), ajratish yo'q
 *   cent.noSeparation   critical  Σ = 0 (n = 0 yoki baraban to'la) — turg'un hisob
 *   cent.lowRecovery    warning   η < 50 % (params: recovery)
 *   cent.stokesInvalid  info      Re_p > 1 — Stokes qonuni chegarasidan tashqari (params: re)
 */
import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import type { CentrifugeInputs, CentrifugeOutputs, CentrifugeParams, CentrifugeState } from './types';

export const centrifuge: UnitModel<CentrifugeParams, CentrifugeInputs, CentrifugeState, CentrifugeOutputs, CentrifugeOutputs> = {
  id: 'centrifuge',
  init: initState,
  step: stepDynamic,
  steady: solveSteady,
};

export * from './types';
export { evaluate as evaluateCentrifuge, sigmaFactor, effectiveRadius, stokesVelocity, overallRecovery, validateCentrifugeParams, validateCentrifugeInputs, G } from './steady';

